import React, { useState, useRef, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";
import "./RevenuePieChart.scss";

const CustomTooltip = ({ active, payload, coords }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;
    return (
      <div
        style={{
          position: "fixed",
          left: `${coords.x + 15}px`,
          top: `${coords.y + 15}px`,
          background: "rgba(255,255,255,0.95)",
          padding: "10px",
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: "6px",
          boxShadow: "0 3px 5px rgba(0,0,0,0.1)",
          zIndex: 1000,
          pointerEvents: "none",
          willChange: "transform",
          transition: "transform 0.05s ease-out",
          transform: "scale(1.01)",
        }}
      >
        <p
          style={{
            margin: 0,
            marginBottom: "5px",
            fontWeight: "bold",
            color: "#333",
          }}
        >
          {data.name}
        </p>
        <p
          style={{
            margin: 0,
            color: "#666",
          }}
        >
          $
          {data.value
            ? data.value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : ""}
        </p>
      </div>
    );
  }
  return null;
};

const RevenuePieChart = ({ colors, data }) => {
  const [mouseCoords, setMouseCoords] = useState({ x: 0, y: 0 });
  const rafRef = useRef(null);

  useEffect(() => {
    // Cleanup function to cancel animation frame
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  const handleMouseMove = (e) => {
    // Cancel previous animation frame
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
    }

    // Schedule new animation frame
    rafRef.current = requestAnimationFrame(() => {
      setMouseCoords({
        x: e.clientX,
        y: e.clientY,
      });
    });
  };

  const CustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    name,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius + 100; // Move labels slightly outside the pie
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y} // Adjust this value to add paddingTop
        fill="black"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={14}
      >
        {`${name} (${(percent * 100).toFixed(1)}%)`}
      </text>
    );
  };

  return (
    <div onMouseMove={handleMouseMove} className="frame-revenue-pie-chart">
      <PieChart width={650} height={350} className="revenue-pie-chart">
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={120}
          dataKey="value"
          label={CustomLabel}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors[index % colors.length]}
              style={{
                cursor: "pointer",
                willChange: "transform",
                transition: "transform 0.1s ease",
              }}
            />
          ))}
        </Pie>
        <Tooltip
          content={<CustomTooltip coords={mouseCoords} />}
          cursor={false}
        />
        <Legend />
      </PieChart>
    </div>
  );
};

export default RevenuePieChart;
